var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuctionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21852",
    "data-name": "\\uADF8\\uB8F9 21852",
    transform: "translate(-1430 -415)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28236",
    "data-name": "\\uC0AC\\uAC01\\uD615 28236",
    width: 24,
    height: 24,
    transform: "translate(1430 415)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21851",
    "data-name": "\\uADF8\\uB8F9 21851",
    transform: "translate(-276.647 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10301",
    "data-name": "\\uD328\\uC2A4 10301",
    d: "M400.529,28.475a10.118,10.118,0,0,1-9.948-10.258,9.953,9.953,0,1,1,19.9,0,10.118,10.118,0,0,1-9.948,10.258m0-18.334a7.966,7.966,0,0,0-7.832,8.076,7.836,7.836,0,1,0,15.664,0,7.966,7.966,0,0,0-7.832-8.076",
    transform: "translate(1318 395.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10302",
    "data-name": "\\uD328\\uC2A4 10302",
    d: "M411.95,24.019a1.075,1.075,0,0,1-1.058-1.091v-5.5a1.058,1.058,0,1,1,2.116,0v5.5a1.075,1.075,0,0,1-1.058,1.091",
    transform: "translate(1306.579 390.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10303",
    "data-name": "\\uD328\\uC2A4 10303",
    d: "M426.025,13.6a1.04,1.04,0,0,1-.748-.319l-2.012-2.074a1.115,1.115,0,0,1,0-1.543L425.1,7.774a1.036,1.036,0,0,1,1.5,0l2.012,2.074a1.115,1.115,0,0,1,0,1.543l-1.834,1.892a1.038,1.038,0,0,1-.748.32m-.516-3.165.516.531.338-.349-.516-.531Z",
    transform: "translate(1299.796 395.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10304",
    "data-name": "\\uD328\\uC2A4 10304",
    d: "M410.963,6.041A1.034,1.034,0,0,1,410.674,6a7.624,7.624,0,0,0-4.3,0,1.049,1.049,0,0,1-1.257-.609,3.91,3.91,0,0,1-.317-1.549,3.727,3.727,0,1,1,7.45,0,3.91,3.91,0,0,1-.317,1.549,1.057,1.057,0,0,1-.968.651m-2.44-2.533a9.691,9.691,0,0,1,1.6.133,1.6,1.6,0,0,0-3.2,0,9.691,9.691,0,0,1,1.6-.133",
    transform: "translate(1310.005 400)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionIcon);
export default __webpack_public_path__ + "static/media/auctionIcon.f4e6d1f92be8abed7b3083c4db6866c8.svg";
export { ForwardRef as ReactComponent };